module.exports = __webpack_public_path__ + "assets/8679eafc407b5abfefdc256138fbdfc7.svg";